import { writable } from 'svelte/store';

import { overlayModel } from '@shared/ui/overlay';

function createSidebarActivity() {
  const { subscribe, set, update } = writable(false);

  return {
    subscribe,
    toggle: () => {
      update((n) => !n);
      overlayModel.overlayActivity.toggle();
    },
    close: () => {
      overlayModel.overlayActivity.close();
      set(false);
    },
  };
}

export const walletSidebarActivity = createSidebarActivity();
